import { ApplicationConfig, DEFAULT_CURRENCY_CODE } from '@angular/core';
import { provideRouter, withComponentInputBinding, withViewTransitions } from '@angular/router';
import { MAT_DATE_LOCALE, provideNativeDateAdapter } from '@angular/material/core';
import { AUTH_COUNTRY_KEY, provideTranslations, sharedProviders } from '@rezevent/core';
import { BASE_PATH } from '@rezevent/api-types';
import { routes } from './app.routes';
import { environment } from '../environments/environment';

export const appConfig: ApplicationConfig = {
  providers: [
    ...sharedProviders,
    provideRouter(routes, withViewTransitions(), withComponentInputBinding()),
    provideNativeDateAdapter(),
    { provide: MAT_DATE_LOCALE, useValue: 'en-GB' },
    { provide: DEFAULT_CURRENCY_CODE, useValue: '' },
    { provide: BASE_PATH, useValue: environment.apiUrl },
    provideTranslations(AUTH_COUNTRY_KEY),
  ],
};
